define('LNRS/Components/Jobs/JobSearchResults',[
    "jquery",
    "eventManager",
    "Search/Search",
    "instantsearch",
    "text!LNRS/Components/Jobs/Templates/JobSearchResultsItem.html",
    "Track/Events"
], function ($, eventManager, Search, instantsearch, itemTemplate, events) {

        function JobSearchResults(scope, searchResultsId, hitsPerPage, noResultsLabel, searchStatisticsId, numberOfResultsPluralLabel, numberOfResultsSingularLabel, downloadItemTemplateId, newsTemplateId) {
        Search.addWidget(
            instantsearch.widgets.hits({
                container: '#' + searchResultsId,
                templates: {
                    empty: "<div class='no-results'>" + noResultsLabel + "</div>",
                    item: itemTemplate
                },
                transformData: {
                    item: function (hit) {
                        // "<link linktype="external" url="http://www.cardrates.com/news/lexisnexis-risk-solutions-improves-small-business-lending/" />"
                        hit["url"] = hit["_template"] === downloadItemTemplateId ? hit["link to pdf"]
                            : hit["_template"] === newsTemplateId ? hit["_news_link"]
                            : hit["url"];
                        hit["openInNew"] = hit["_template"] === newsTemplateId || hit["_template"] === downloadItemTemplateId;

                        if (hit["url"]) {
                            hit["url-label"] = hit["url"].replace('//', "\/\/");
                        }

                        var today = new Date(Date.now());
                        var startDate = new Date(hit["start_date"]);


                        var Difference_In_Time = today.getTime() - startDate.getTime();
                        var Difference_In_Days = Math.round(Difference_In_Time / (1000 * 3600 * 24));
                        if (Difference_In_Days == 0) {
                            hit["posted"] = "Posted Today"
                        }
                        else if (Difference_In_Days == 1) {
                            hit["posted"] = "Posted Yesterday"
                        }
                        else if (Difference_In_Days > 30) {
                            hit["posted"] = "Posted 30+ days ago"
                        }
                        else {
                            hit["posted"] = "Posted " + Difference_In_Days + " days ago"
                        }

                        if (hit["job_requisition_primary_location"]) {
                            hit["job_requisition_primary_location"] = hit["job_requisition_primary_location"] + " | ";
                        }
                        else if (hit["country"]) {
                            hit["job_requisition_primary_location"] = hit["country"] + " | ";
                        }
                        
                        return hit;
                    }
                },
                hitsPerPage: hitsPerPage
            })
        );

        /*var oneItemText = numberOfResultsSingularLabel.replace("#", "{{nbHits}}");
        var manyItemsText = numberOfResultsPluralLabel.replace("#", "{{nbHits}}");

        Search.addWidget(
            instantsearch.widgets.stats({
                container: '#' + searchStatisticsId,
                templates: {
                    body: '{{#query}}{{#hasNoResults}}' + noResultsLabel + ' "{{query}}"{{/hasNoResults}}{{#hasOneResult}}' + oneItemText + ' "{{query}}"{{/hasOneResult}}{{#hasManyResults}}' + manyItemsText + ' "{{query}}"{{/hasManyResults}}{{/query}}'
                }
            })
        );*/

        $(scope).on("click", ".ais-hits--item", function (ev) {
            var searchProvider = Search.search, el = ev.currentTarget;
            eventManager.trigger("Search-Result-selected", searchProvider, el);
        });

        eventManager.subscribe(events.global.algoliaRendered, function (searchProvider) {
            var nbHits = searchProvider.helper.lastResults.nbHits;
            if (nbHits == 0) {
                $('#' + searchStatisticsId).html('');
            }
            else {
                if (searchProvider.helper.lastResults.query) {
                    if (nbHits == 1) {
                        var resultText = numberOfResultsSingularLabel.replace("#", searchProvider.helper.lastResults.nbHits);
                        $('#' + searchStatisticsId).html(resultText + ' "' + searchProvider.helper.lastResults.query + '"');
                    }
                    else {
                        var resultText = numberOfResultsPluralLabel.replace("#", searchProvider.helper.lastResults.nbHits);
                        $('#' + searchStatisticsId).html(resultText + ' "' + searchProvider.helper.lastResults.query + '"');
                    }
                }
                else {

                    if (nbHits == 1) {
                        var resultText = numberOfResultsSingularLabel.replace("#", searchProvider.helper.lastResults.nbHits);
                        $('#' + searchStatisticsId).html(resultText);
                    }
                    else {
                        var resultText = numberOfResultsPluralLabel.replace("#", searchProvider.helper.lastResults.nbHits);
                        $('#' + searchStatisticsId).html(resultText);
                    }
                }
            } 
        });
    }

    return function InitJobSearchResults(args) {
        return args.IsExperienceEditorEditing ? null : new JobSearchResults(
            args.scope,
            args.SearchResultsId,
            args.HitsPerPage,
            args.NoResultsLabel,
            args.SearchStatisticsId,
            args.NumberOfResultsPluralLabel,
            args.NumberOfResultsSingularLabel,
            args.DownloadItemTemplateId,
            args.InTheNewsTemplateId);
    }
});
